import { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { IndexList } from './list/Index';
import { SellYourProperty } from './sellyourproperty/Index';
import { BeOurAgent } from './beouragent/Index';
import { MessageUs } from './messageus/Index';
import { ToolContext } from '../../../../../../../core/context/ToolContext';
import { rqx } from '../../../../../../../core/request/API';
import { env } from '../../../../../../../core/Env';
import MobileFrame from '../mystyles/Index';

export const RealProperty = ({ tab }) => {
    const { website_state, tool_state } = useContext(ToolContext);
    const { templateForm, tLoader, loader, inftScroll, lastId, cooldown, hasMore, isLoading } = website_state;
    const { __SESSION } = tool_state
    const td = templateForm.data;
    const company_id = __SESSION.data.uaccess[0].company_id
    const menu = new URLSearchParams(window.location.search).get('menu');

    const getProperties = async (val) => {
        if (val === 0) {
            loader.set(true);
            inftScroll.set(true);
        }
        isLoading.set(true);
        const res_list = await rqx.get(`<<shp>>/${env()}/realproperty/read`, {
            lastId: val,
            limit: 10,
            type: "per-company",
            company_id: company_id //2,
        });

        if (res_list) {
            const last_id = res_list.length > 0 ? res_list[res_list.length - 1].id : val;
            lastId.set(last_id);

            if (val === 0 || val === undefined || val === "") {
                templateForm.set((p) => ({
                    ...p,
                    realListing: res_list,
                }));
            } else {
                templateForm.set((p) => ({
                    ...p,
                    realListing: [...p.realListing, ...res_list],
                }));
            }

            // if less than limit (10) means no more data to load. stop infinite scroll
            if (res_list.length < 10) {
                inftScroll.set(false);
                hasMore.set(false);
            }
        }
        isLoading.set(false);
        loader.set(false);
    };

    const loadMoreProperties = async () => {
        if (cooldown.data || isLoading.data || !hasMore.data) return;
        cooldown.set(true);
        await getProperties(lastId.data);
        setTimeout(() => cooldown.set(false), 500); // wait 500ms before allowing another trigger
    };

    useEffect(() => {
        hasMore.set(true)
        getProperties(0)
        // eslint-disable-next-line
    }, [])

    const component = () => {
        if (menu === "property-rent" || menu === "property-buy" ) {
            return <IndexList tLoader={tLoader} td={td} templateForm={templateForm} loadMoreProperties={loadMoreProperties} company_id={company_id}/>
        } else if (menu === "sell-your-property") {
            return <SellYourProperty/>
        } else if (menu === "be-our-agent") {
            return <BeOurAgent/>
        } else if (menu === "message-us") {
            return <MessageUs/>
        } else {
            <Box> 404 Error </Box>
        }
    }
    
    return (
        <Box height="100%" width="100%" className='overflowY' display="flex" flexDirection="column" alignItems="center">
            {tab === 'mobile' &&
                <Box my='2rem' borderRadius={2}
                    // width="18vw"
                    // height="60vh"
                    width="338px"
                    height= "568px"
                >
                    {/* <Box width={335} height={635} marginTop='25px' borderRadius={2}> */}
                    <Box width="100%" height="100%" style={{ display: 'flex', justifyContent: 'center' }} >
                        <MobileFrame tLoader={tLoader} td={td} company_id={company_id}>
                            {component()}
                        </MobileFrame>
                    </Box>
                </Box>
            }
        </Box>
    );
}

